import { render, staticRenderFns } from "./upload.vue?vue&type=template&id=4ca687fa&scoped=true"
import script from "./upload.vue?vue&type=script&lang=js"
export * from "./upload.vue?vue&type=script&lang=js"
import style0 from "./upload.vue?vue&type=style&index=0&id=4ca687fa&prod&lang=scss"
import style1 from "./upload.vue?vue&type=style&index=1&id=4ca687fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca687fa",
  null
  
)

export default component.exports